<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Solicitudes Internas</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Carga Seca e Izajes</li>
                  <li class="breadcrumb-item active">Internas</li>
                  <li class="breadcrumb-item active">Solicitudes</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card" style="display: inherit">
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <div class="col-md-10"></div>
                  <div class="col-md-12">
                    <div class="btn-group float-right">
                      <button
                        type="button"
                        class="btn btn-success"
                        data-toggle="modal"
                        data-target="#modal_export_solInte"
                        @click="limpiarExport()"
                        v-if="
                          $store.getters.can(
                            'funcionariofrontera.csSolicitudInterna.export'
                          )
                        "
                      >
                        <i class="far fa-file-excel"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        v-if="
                          $store.getters.can(
                            'funcionariofrontera.csSolicitudInterna.create'
                          )
                        "
                        @click="create()"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                      <button
                        type="button"
                        class="btn bg-navy"
                        @click="getIndex()"
                      >
                        <i class="fas fa-sync-alt"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="limpiarFiltro()"
                      >
                        <i class="fas fa-broom"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body pb-0">
                <div class="row justify-content-center">
                  <div class="form-group col-md-1">
                    <label># Solicitud</label>
                    <input
                      type="number"
                      class="form-control form-control-sm"
                      v-model="filtros.id"
                      @input="getIndex()"
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label>Nombre Usuario</label>
                    <input
                      type="text"
                      class="form-control form-control-sm p-0"
                      v-model="filtros.user"
                      @input="getIndex()"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Tipo Solicitud</label>
                    <select
                      v-model="filtros.tipo_solicitud"
                      class="form-control form-control-sm"
                      placeholder="Tipo Solicitud"
                      label="descripcion"
                      @change="getIndex()"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="estado in listasForms.tipos_solicitudes"
                        :key="estado.numeracion"
                        :value="estado.numeracion"
                      >
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group col-md-2">
                    <label>Fecha</label>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      v-model="filtros.fecha"
                      @input="getIndex()"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Estado</label>
                    <select
                      class="form-control form-control-sm"
                      v-model="filtros.estado"
                      @change="getIndex()"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="estado in listasForms.estados"
                        :key="estado.numeracion"
                        :value="estado.numeracion"
                      >
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive p-0">
                <table
                  class="table table-bordered table-striped table-hover table-sm"
                  style="font-size: 0.9em"
                >
                  <thead class="thead bg-dark">
                    <tr class="text-center">
                      <th class="col-1">#</th>
                      <th>Nombre Usuario</th>
                      <th class="col-1">Tipo Solicitud</th>
                      <th class="col-1">Clase Solicitud</th>
                      <th class="col-1">Fecha</th>
                      <th>Justificación</th>
                      <th>Observaciones</th>
                      <th class="col-1">Estado</th>
                      <th class="col-1">Acciones</th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="solicitud in solicitudes.data"
                    :key="solicitud.id"
                  >
                    <tr>
                      <td class="text-center">
                        <button
                          type="button"
                          class="btn btn-xs btn-default"
                          data-toggle="modal"
                          data-target="#modal-form-detalle-CsIntSolicitud"
                          @click="llenarModal(solicitud)"
                        >
                          {{ solicitud.id }}
                        </button>
                      </td>
                      <td>{{ solicitud.user.name }}</td>
                      <td class="text-center">
                        <span
                          class="badge"
                          :class="
                            solicitud.tipo_solicitud == 1
                              ? 'bg-navy'
                              : 'bg-danger'
                          "
                          >{{ solicitud.tipoSolicitud }}</span
                        >
                        <div
                          class="row justify-content-center"
                          v-if="solicitud.tipo_emergencia == 2"
                        >
                          <span class="badge bg-pink">Extemporaneo</span>
                        </div>
                      </td>
                      <td class="text-center">
                        <span
                          class="badge"
                          :class="
                            solicitud.clase_solicitud == 1
                              ? 'bg-navy'
                              : 'bg-lime'
                          "
                          >{{ solicitud.claseSolicitud }}</span
                        >
                      </td>
                      <td class="text-center">{{ solicitud.fecha }}</td>
                      <td>
                        <small>{{ solicitud.justificacion }}</small>
                      </td>
                      <td>
                        <small>{{ solicitud.observaciones }}</small>
                      </td>
                      <td class="text-center">
                        <span
                          class="badge"
                          :class="
                            solicitud.estado == 1
                              ? 'badge-info'
                              : solicitud.estado == 2
                              ? 'badge-success'
                              : solicitud.estado == 3
                              ? 'badge-danger'
                              : solicitud.estado == 4
                              ? 'badge-primary'
                              : solicitud.estado == 5
                              ? 'bg-warning'
                              : ''
                          "
                        >
                          {{ solicitud.estado }}. {{ solicitud.nEstado }}
                        </span>
                      </td>
                      <td class="text-right">
                        <div class="btn-group float-right">
                          <button
                            type="button"
                            data-toggle="modal"
                            data-target="#modal-form-servicios"
                            class="btn btn-sm btn-warning"
                            v-if="
                              $store.getters.can(
                                'funcionariofrontera.csSolicitudInterna.edit'
                              ) &&
                                (solicitud.estado == 2 || solicitud.estado == 4)
                            "
                            @click="
                              $refs.CsSolicitudesInternasServicios.getServicios(
                                solicitud
                              )
                            "
                          >
                            <i class="fas fa-users-cog"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm bg-navy"
                            v-if="
                              $store.getters.can(
                                'funcionariofrontera.csSolicitudInterna.edit'
                              ) &&
                                solicitud.estado != 2 &&
                                  solicitud.estado != 3 &&
                                  solicitud.estado != 4
                            "
                            @click="edit(solicitud, 1)"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm bg-info"
                            v-if="
                              $store.getters.can(
                                'funcionariofrontera.csSolicitudInterna.show'
                              ) &&
                                (solicitud.estado == 2 ||
                                  solicitud.estado == 3 ||
                                  solicitud.estado == 4)
                            "
                            @click="edit(solicitud, 2)"
                          >
                            <i class="fas fa-eye"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="solicitudes.total">
                  Mostrando del <b>{{ solicitudes.from }}</b> al
                  <b>{{ solicitudes.to }}</b> de un total:
                  <b>{{ solicitudes.total }}</b> Registros
                </div>
                <div class="float-left" v-else>
                  <span class="badge badge-danger">
                    No hay registros para mostrar
                  </span>
                </div>
                <pagination
                  :data="solicitudes"
                  @pagination-change-page="getIndex"
                  :limit="5"
                  class="float-right m-0"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <CsSolicitudesIntDetalle ref="CsSolicitudesIntDetalle" />
    <CsSolicitudesInternasServicios ref="CsSolicitudesInternasServicios" />
    <CsSolicitudesInternasExport
      ref="CsSolicitudesInternasExport"
    ></CsSolicitudesInternasExport>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "../../../../components/Loading";
import pagination from "laravel-vue-pagination";
import CsSolicitudesIntDetalle from "./CsSolicitudesIntDetalle";
import CsSolicitudesInternasServicios from "./CsSolicitudesInternasServicios";
import CsSolicitudesInternasExport from "./CsSolicitudesInternasExport";

export default {
  name: "SolicitudesInternasIndex",

  components: {
    Loading,
    pagination,
    CsSolicitudesIntDetalle,
    CsSolicitudesInternasServicios,
    CsSolicitudesInternasExport,
  },

  data() {
    return {
      cargando: false,
      filtros: {},
      solicitudes: {},
      listasForms: {
        tipos_solicitudes: [],
        estados: [],
      },
    };
  },

  methods: {
    getIndex(page = 1) {
      this.cargando = true;
      this.filtros.accion = 1;
      axios
        .get(
          "/api/funcionariosFrontera/solicitudesInternas/index?page=" + page,
          {
            params: this.filtros,
          }
        )
        .then((response) => {
          this.solicitudes = response.data;
          this.cargando = false;
        })
        .catch(function(error) {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    getTipoSolicitud() {
      axios.get("/api/lista/127").then((response) => {
        this.listasForms.tipos_solicitudes = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/135").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    create() {
      return this.$router.push({
        name: "/CargaSeca/SolicitudesInternasForm",
        params: { accion: "Crear" },
      });
    },

    edit(solicitud, act) {
      return this.$router.push({
        name: "/CargaSeca/SolicitudesInternasForm",
        params: { accion: "Editar", data_edit: solicitud, act: act },
      });
    },

    llenarModal(solicitud) {
      if (this.$store.getters.can("tep.solicitudes.detalle")) {
        this.$refs.CsSolicitudesIntDetalle.llenar_modal(solicitud);
      }
    },

    limpiarFiltro() {
      this.filtros = {};
      this.getIndex();
    },

    limpiarExport() {
      (this.$refs.CsSolicitudesInternasExport.filtros = {
        gerente_area_id: null,
        bloque_id: null,
        sitio_id: null,
        fecha_inicial: null,
        fecha_final: null,
        tipo_solicitud: null,
      }),
        this.getIndex();
    },
  },

  beforeMount() {
    this.getTipoSolicitud();
    this.getEstados();
  },

  mounted() {
    this.getIndex();
  },
};
</script>
